var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0033 19.2841L1.87691 10.1577C1.14893 9.42969 0.663604 8.58333 0.420943 7.61861C0.184201 6.65388 0.18716 5.69508 0.429821 4.74219C0.672482 3.78338 1.15484 2.94886 1.87691 2.23864C2.61673 1.51065 3.46012 1.02829 4.40709 0.791548C5.35998 0.548887 6.30991 0.548887 7.25688 0.791548C8.20977 1.03421 9.05612 1.51657 9.79594 2.23864L11.0033 3.41051L12.2107 2.23864C12.9565 1.51657 13.8028 1.03421 14.7498 0.791548C15.6967 0.548887 16.6437 0.548887 17.5907 0.791548C18.5436 1.02829 19.3899 1.51065 20.1298 2.23864C20.8518 2.94886 21.3342 3.78338 21.5768 4.74219C21.8195 5.69508 21.8195 6.65388 21.5768 7.61861C21.3401 8.58333 20.8577 9.42969 20.1298 10.1577L11.0033 19.2841Z",
    fill: "#FF1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d131dc240a0580fb3bcecf92e943d77a.svg";
export { ForwardRef as ReactComponent };